export const webConfig = {
    API_HOST: `${process.env.REACT_APP_API_URL}/api/v1/`,
    CLIENT_ID: process.env.REACT_APP_CLIENT_ID,
    CLIENT_SECRET: process.env.REACT_APP_CLIENT_SECRET,
    AUTOBAHN_CONNECTION: process.env.REACT_APP_AUTOBAHN,
    AUTOBAHN_CONNECTION_CHROME_HACK: process.env.REACT_APP_AUTOBAHN_CHROME_HACK,
    REDIRECT_URL: '/login',
    LOCAL_STORAGE_SESSION_KEY: 'dalipro_remote_auth',
    LOCAL_STORAGE_REMOTE_SESSION_KEY: 'dalipro_remote_token',
    SITES_API: 'sites/',
    AUTHORIZE_API: 'oauth/authorize',
    TOKEN_API: 'oauth/token',
    USER_API: 'users/',
    ORG_API: 'organizations/',
    ORG_UUID: 'c4211aa2-79e4-47d4-b459-a2a6e8094ede',
    FRONTEND_URL: process.env.REACT_APP_URL,
    LEDVANCE: process.env.REACT_APP_LEDVANCE
  };

  export const webApiGrantType = {
    refresh_token:'refresh_token',
    authorization_code: 'authorization_code',
  };